import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FormlyModule } from '@ngx-formly/core';
import { NgxMaskDirective } from 'ngx-mask';

import { ClearOnFocusDirective } from '@lockton-apps/shared/util/form-utils';
import { CurrencyMaskDirective } from '@lockton-apps/shared/ui/lui';

import { InputFieldTypeComponent } from './input-field-type.component';

@NgModule({
  declarations: [InputFieldTypeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    NgxMaskDirective,
    CurrencyMaskDirective,
    ClearOnFocusDirective,

    FormlyModule.forChild({
      types: [
        {
          name: 'input',
          component: InputFieldTypeComponent,
          wrappers: ['mat-form-field', 'addons'],
        },
        { name: 'string', extends: 'input' },
        {
          name: 'number',
          extends: 'input',
          defaultOptions: {
            props: {
              type: 'number',
            },
          },
        },
        {
          name: 'percentage',
          extends: 'input',
          defaultOptions: {
            defaultValue: 0,
            props: {
              clearOnFocus: 'zero',
              type: 'percentage',
              addonRight: '%',
              max: 100,
              min: 0,
              currencyOptions: {
                precision: 0,
              },
            },
            validation: {
              messages: {
                max: $localize`Max 100%`,
              },
            },
          },
        },
        {
          name: 'currency',
          extends: 'input',
          defaultOptions: {
            defaultValue: 0,
            props: {
              type: 'currency',
              clearOnFocus: 'zero',
              currencyOptions: {
                precision: 2,
              },
            },
          },
        },
        {
          name: 'email',
          extends: 'input',
          defaultOptions: {
            props: {
              type: 'email',
            },
            validators: {
              validation: ['email'],
            },
          },
        },
        {
          name: 'tel',
          extends: 'input',
          defaultOptions: {
            props: {
              type: 'tel',
            },
          },
        },
      ],
    }),
  ],
})
export class InputFieldTypeModule {}
